/**
 * @generated SignedSource<<fdffdb2ab8e614c8e45201981f08afb7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpsertAnthropicIntegrationInput = {
  adminKey?: string | null | undefined;
  orgId: string;
};
export type UpsertAnthropicIntegrationMutation$variables = {
  input: UpsertAnthropicIntegrationInput;
};
export type UpsertAnthropicIntegrationMutation$data = {
  readonly upsertAnthropicIntegration: {
    readonly anthropicIntegration: {
      readonly configured: boolean;
      readonly id: string;
      readonly orgId: string;
    } | null | undefined;
    readonly problems: ReadonlyArray<{
      readonly __typename: string;
      readonly message: string;
    }>;
  };
};
export type UpsertAnthropicIntegrationMutation = {
  response: UpsertAnthropicIntegrationMutation$data;
  variables: UpsertAnthropicIntegrationMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpsertAnthropicIntegrationPayload",
    "kind": "LinkedField",
    "name": "upsertAnthropicIntegration",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "AnthropicIntegration",
        "kind": "LinkedField",
        "name": "anthropicIntegration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "configured",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "orgId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "problems",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpsertAnthropicIntegrationMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "UpsertAnthropicIntegrationMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "5e807e86583d52a52fff0a451ff787a8",
    "id": null,
    "metadata": {},
    "name": "UpsertAnthropicIntegrationMutation",
    "operationKind": "mutation",
    "text": "mutation UpsertAnthropicIntegrationMutation(\n  $input: UpsertAnthropicIntegrationInput!\n) {\n  upsertAnthropicIntegration(input: $input) {\n    anthropicIntegration {\n      configured\n      id\n      orgId\n    }\n    problems {\n      __typename\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e507ffd85c222002cca115f48a3f4802";

export default node;
